import { App, KernelRouteEndpoint, KernelRoute } from "../../../kernel/kernel";
import raf from "raf";

/**
 * Login route
 *
 * @extends KernelRoute
 */
class LoginRoute extends KernelRoute {

    /**
     * When the user hits the index page, show the index page
     */
    @KernelRouteEndpoint("/login(/)")
    @KernelRouteEndpoint("(/)")
    route (params) {
        App.hideNavigation();

        System.import("./index").then(View => {
            const view = new View.default({
                params: params
            });
            raf(_ => App.contentRegion.show(view));
        });
    }
}

export default LoginRoute;



// WEBPACK FOOTER //
// ./public/domain/views/login/login.route.js